// extracted by css-extract-rspack-plugin
export default {"participantsLoadingContainer":"ParticipantsListLoading-module__participantsLoadingContainer__SeikO"};